//
// This is a generated file. DO NOT EDIT IT.
// Instead run:
//
// npm ci
// npm generate:icons
//
export default {
  "Action Plan Builder-1": "/images/icons/Action Plan Builder-1.svg",
  "Action Plan Builder-2": "/images/icons/Action Plan Builder-2.svg",
  "Action Plan Builder": "/images/icons/Action Plan Builder.svg",
  "Amex": "/images/icons/Amex.svg",
  "Calendar-Add": "/images/icons/Calendar-Add.svg",
  "Cancer-Brain": "/images/icons/Cancer-Brain.svg",
  "Cancer-Breast": "/images/icons/Cancer-Breast.svg",
  "Cancer-Cervical": "/images/icons/Cancer-Cervical.svg",
  "Cancer-Colon": "/images/icons/Cancer-Colon.svg",
  "Cancer-Esophageal": "/images/icons/Cancer-Esophageal.svg",
  "Cancer-Kidney": "/images/icons/Cancer-Kidney.svg",
  "Cancer-Larynx": "/images/icons/Cancer-Larynx.svg",
  "Cancer-Leukemia": "/images/icons/Cancer-Leukemia.svg",
  "Cancer-Liver": "/images/icons/Cancer-Liver.svg",
  "Cancer-Lung": "/images/icons/Cancer-Lung.svg",
  "Cancer-Lymphoma": "/images/icons/Cancer-Lymphoma.svg",
  "Cancer-Melanoma": "/images/icons/Cancer-Melanoma.svg",
  "Cancer-Myeloma": "/images/icons/Cancer-Myeloma.svg",
  "Cancer-Oral": "/images/icons/Cancer-Oral.svg",
  "Cancer-Ovarian": "/images/icons/Cancer-Ovarian.svg",
  "Cancer-Pancreas": "/images/icons/Cancer-Pancreas.svg",
  "Cancer-Prostate": "/images/icons/Cancer-Prostate.svg",
  "Cancer-Stomach": "/images/icons/Cancer-Stomach.svg",
  "Cancer-Testicular": "/images/icons/Cancer-Testicular.svg",
  "Cancer-Thyroid": "/images/icons/Cancer-Thyroid.svg",
  "Cancer-Urinary": "/images/icons/Cancer-Urinary.svg",
  "Cancer-Uterine": "/images/icons/Cancer-Uterine.svg",
  "Clinical-Dr": "/images/icons/Clinical-Dr. Visit.svg",
  "Clinical-Labwork": "/images/icons/Clinical-Labwork.svg",
  "Clinical-Scans": "/images/icons/Clinical-Scans.svg",
  "Clinical-Shots": "/images/icons/Clinical-Shots.svg",
  "Diet-Beverages": "/images/icons/Diet-Beverages.svg",
  "Diet-Coffee": "/images/icons/Diet-Coffee.svg",
  "Diet-Dairy": "/images/icons/Diet-Dairy.svg",
  "Diet-Fruits-&-Veggies": "/images/icons/Diet-Fruits-&-Veggies.svg",
  "Diet-General": "/images/icons/Diet-General.svg",
  "Diet-Meat & Fish": "/images/icons/Diet-Meat & Fish.svg",
  "Diet-Whole Grains": "/images/icons/Diet-Whole Grains.svg",
  "Discover": "/images/icons/Discover.svg",
  "Empty State Icons-1": "/images/icons/Empty State Icons-1.svg",
  "Empty State Icons": "/images/icons/Empty State Icons.svg",
  "Excercise-Cardio": "/images/icons/Excercise-Cardio.svg",
  "Excercise-Strength": "/images/icons/Excercise-Strength.svg",
  "Exercise-General": "/images/icons/Exercise-General.svg",
  "Icon": "/images/icons/Icon.svg",
  "Mastercard": "/images/icons/Mastercard.svg",
  "Misc-Environmental": "/images/icons/Misc-Environmental.svg",
  "Misc-Home": "/images/icons/Misc-Home.svg",
  "Misc-Skin": "/images/icons/Misc-Skin.svg",
  "Misc-Smokin": "/images/icons/Misc-Smokin.svg",
  "Misc-Sun": "/images/icons/Misc-Sun.svg",
  "Misc-Supplements": "/images/icons/Misc-Supplements.svg",
  "Misc-Weight": "/images/icons/Misc-Weight.svg",
  "Profile-User": "/images/icons/Profile-User.svg",
  "Visa": "/images/icons/Visa.svg",
  "alert-01": "/images/icons/alert-01.svg",
  "alert-02": "/images/icons/alert-02.svg",
  "alert-03": "/images/icons/alert-03.svg",
  "angle": "/images/icons/angle.svg",
  "bill": "/images/icons/bill.svg",
  "biomarkers-alt-1": "/images/icons/biomarkers-alt-1.svg",
  "biomarkers-alt-2": "/images/icons/biomarkers-alt-2.svg",
  "biomarkers": "/images/icons/biomarkers.svg",
  "builder-alt-1": "/images/icons/builder-alt-1.svg",
  "builder-alt-2": "/images/icons/builder-alt-2.svg",
  "builder-alt": "/images/icons/builder-alt.svg",
  "builder": "/images/icons/builder.svg",
  "circle-check-1": "/images/icons/circle-check-1.svg",
  "congrats-01": "/images/icons/congrats-01.svg",
  "congrats-02": "/images/icons/congrats-02.svg",
  "congrats-03": "/images/icons/congrats-03.svg",
  "congrats-04": "/images/icons/congrats-04.svg",
  "congrats-nobg-02": "/images/icons/congrats-nobg-02.svg",
  "congrats-nobg-03": "/images/icons/congrats-nobg-03.svg",
  "congrats-nobg-04": "/images/icons/congrats-nobg-04.svg",
  "congrats-nobg-05": "/images/icons/congrats-nobg-05.svg",
  "credit-card": "/images/icons/credit-card.svg",
  "demographics": "/images/icons/demographics.svg",
  "disabled-dot": "/images/icons/disabled-dot.svg",
  "dot": "/images/icons/dot.svg",
  "how-to-accomplish": "/images/icons/how-to-accomplish.svg",
  "info": "/images/icons/info.svg",
  "insurance": "/images/icons/insurance.svg",
  "lock": "/images/icons/lock.svg",
  "minus": "/images/icons/minus.svg",
  "occupation-alt": "/images/icons/occupation-alt.svg",
  "occupation": "/images/icons/occupation.svg",
  "predictive-value": "/images/icons/predictive-value.svg",
  "right": "/images/icons/right.svg",
  "risk-impact": "/images/icons/risk-impact.svg",
  "shield": "/images/icons/shield.svg",
  "task-list-edit": "/images/icons/task-list-edit.svg",
  "test-options-light": "/images/icons/test-options-light.svg",
  "test-options": "/images/icons/test-options.svg",
  "testing-history-light": "/images/icons/testing-history-light.svg",
  "testing-history": "/images/icons/testing-history.svg",
  "why-it-matters": "/images/icons/why-it-matters.svg",
  "wrong": "/images/icons/wrong.svg"
}